import { render, staticRenderFns } from "./kitsView.vue?vue&type=template&id=77376b34"
import script from "./kitsView.vue?vue&type=script&lang=js"
export * from "./kitsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports